<template>
  <b-card>
    <div class="head-detail-resume font--secondary">
      <span v-b-tooltip.hover :title="`CUENTA : ${headData.textContractType}`" class="image-container">
         <img :src="getImage(carrierCode)" class="image" :alt="carrierCode">
      </span>
      <template v-for="(item, index) in headDataItems">
        <div :key="index">
          <div class="item" v-if="!item.slot">
            <span v-b-tooltip.hover :title="item.title" :id="item.id">
              <feather-icon :icon="item.icon"/>{{ item.text }}
            </span>
            <tooltip-array v-if="item.hover && item.hover.tooltip" :objectArray="item.hover.object" :target="item.hover.target"/>
          </div>
          <template v-else>
            <div class="item" v-if="item.slot === 'manifest'">
              <b-button variant="link" v-b-tooltip.hover :title="item.title" class="p-0 text-left head--button-link" @click="openManifest">
                <feather-icon :icon="item.icon"/>
                Manifiesto
                <span class="text-secondary" v-if="headData.deliveryLabelPrintStatusName">
                  [{{ headData.deliveryLabelPrintStatusName }}]
                </span>
                <span class="underline" v-if="headData.deliveryLabelPrintId">
                  Nº {{ headData.deliveryLabelPrintId }}
                </span>
                <span class="text-secondary" v-if="headData.deliveryLabelPrintRow">
                  [FILA: {{ headData.deliveryLabelPrintRow }}]
                </span>
              </b-button>
            </div>
            <div class="item" v-if="item.slot === 'address'">
              <div v-b-tooltip.hover :title="item.title" id="IdHeadSlotTooltipAddress">
                <feather-icon :icon="item.icon"/>
                <span>{{ headData.textFullAddress }}</span>
              </div>
              <tooltip-array :objectArray="headDataAddress" target="IdHeadSlotTooltipAddress"/>
            </div>
          </template>
        </div>
      </template>
    </div>
  </b-card>
</template>
<script>
import tooltipArray from '@/views/modules/tickets/components/General/tooltipArray.vue'
import BaseServices from '@/store/services/index'

export default {
  props: ['ticket', 'isModal', 'masterData'],
  components: { tooltipArray },
  data() {
    return {
      baseService: new BaseServices(this),
      contractTypeOptions: [
        { id: 'PAS', text: 'Pasarela' },
        { id: 'DIS', text: 'Distribución' },
        { id: 'pasarela-pro', text: 'Pasarela-Pro' },
        { id: 'INV', text: 'Logística inversa (Devolución)' }
      ]
    }
  },
  computed: {
    headData() {
      return { 
        trackingNumber: this.ticket?.delivery?.tracking_number || 'Sin información',
        importedId: this.ticket?.delivery?.imported_id || 'Sin información',
        deadLineText: this.ticket?.delivery?.deadline_date || 'Sin información',
        currentDeliveryDate: this.ticket?.current_delivery_status?.date || 'Sin información',
        currentDeliveryText: this.ticket?.current_delivery_status?.name || 'Sin información',
        textContractType: (this.contractTypeOptions.find(el => el.id === this.ticket?.contract_type)?.text) || 'Sin información',
        textTransitDays: this.ticket?.delivery?.transit_days || 'Sin información',
        textFullAddress: this.ticket?.delivery?.destination?.full_address_text || 'Sin información',
        deliveryLabelPrintStatusName: this.masterData?.delivery_details?.delivery_label_print_status_name || '--',
        deliveryLabelPrintId: this.masterData?.delivery_details?.delivery_label_print_id || null,
        deliveryAppLabelUrl: this.masterData?.delivery_details?.delivery_label_app_url || '',
        deliveryLabelPrintRow: this.masterData?.delivery_details?.delivery_label_print_row || null
      }
    },
    headDataAddress() {
      return [
        {text: 'NOMBRE: ', value: this.ticket?.delivery?.customer?.full_name || '--'},
        {text: 'CELULAR: ', value: this.ticket?.delivery?.customer?.phone || '--'},
        {text: 'CORREO: ', value: this.ticket?.delivery?.customer?.email || '--'},
        {text: 'TIPO DE DISTRIBUCIÓN: ', value: this.masterData?.delivery_details?.distribution_type || '--'},
        {text: 'CÓDIGO POSTAL: ', value: this.ticket?.delivery?.destination?.zip_code || '--'},
        {text: 'DIRECCIÓN: ', value: this.ticket?.delivery?.destination?.full_address_text || '--'},
        {text: 'OBSERVACIONES: ', value: this.ticket?.delivery?.destination?.information || '--'}
      ]
    },
    headDataTransitDays() {
      let dimensions = this.ticket?.delivery?.dimensions || '{}'
      if (typeof dimensions === 'string') {
        dimensions = JSON.parse(dimensions || '{}')
      }
      return [
        {text: 'DIAS DE TRANSITO: ', value: this.ticket?.delivery?.transit_days || 'Sin información'},
        {text: 'SERVICIO: ', value: this.ticket?.carrier?.service_code || '--'},
        {text: 'PESO: ', value: this.ticket?.delivery?.weight || '--'},
        {text: 'VOLUMEN[m3]: ', value: this.ticket?.delivery?.volume || '--'},
        {text: 'Nº DE BULTOS: ', value: this.ticket?.delivery?.n_packages || '--'},
        {text: 'VALOR PRODUCTO: ', value: this.ticket?.delivery?.price || '--'},
        {text: '', value: '', space: true},
        {text: 'ALTO: ', value: dimensions?.height || '--'},
        {text: 'ANCHO: ', value: dimensions?.width || '--'},
        {text: 'LARGO: ', value: dimensions?.length || '--'},
        {text: 'DESCRIPCIÓN DEL PRODUCTO: ', value: this.ticket?.delivery?.product || '--'}
      ]
    },
    headDataItems() {
      return [
        { title: 'Fecha de estado de envío', icon: 'CalendarIcon', text: this.headData.currentDeliveryDate },
        { title: 'Fecha limite', icon: 'CalendarIcon', text: this.headData.deadLineText },
        { title: '', icon: 'MapPinIcon', text: '', slot: 'address' },
        { title: 'Estado de envío', icon: 'TruckIcon', text: this.headData.currentDeliveryText },
        { title: 'Ir al manifiesto', icon: 'FileIcon', text: '', slot: 'manifest' },
        { title:'', icon: 'CalendarIcon', text: this.headData.textTransitDays, id: 'IdHeadSlotTooltipTransitDays', hover: { tooltip: true, object: this.headDataTransitDays, target: 'IdHeadSlotTooltipTransitDays' } }
      ]
    },
    carrierCode() {
      return this.ticket?.carrier?.code || ''
    }
  },
  methods: {
    getImage(code) {
      return `https://storage.googleapis.com/enviame-misc/carriers/logos/color/${code.toLowerCase()}.png`
    },
    formatDate(date) {
      return this.$options.filters.dbDateToFormat(date, 'y-LL-dd T')
    },
    openManifest() {
      if (this.headData?.deliveryAppLabelUrl) {
        window.open(this.headData?.deliveryAppLabelUrl, '_blank')
      } else {
        console.error('URL no válida')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head-detail-resume {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 20px;
  color: #044389;
  .feather {
    margin-right: 5px;
  }
  .image-container {
    grid-row: span 2;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image {
    width: 100px;
    max-height: 100px;
    object-fit: contain;
  }
  .head--button-link {
    font-size: 12px;
    font-weight: 400;
  }
}
</style>